// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2pHcs","title":"FrontImage_title__HtJiY"};